import React from "react";
import { FieldInputProps, FieldMetaProps, FastField, Field } from "formik";
import colors from "../../constants/colors";
import { InputOptions } from "./InputOptions";
import { FormikInputProps } from "./FormikInputProps";

import { Switch, FormControlLabel } from "@material-ui/core";

const styles = {
	formControl: {
		marginRight: 16,
		marginBottom: 24,
	},
	formControlLabel: {
		fontSize: ".75rem",
		margin: 0,
		textTransform: "uppercase" as any,
		color: colors.gray600,
	},
};

export const FormikSwitchInput = (props: FormikInputProps) => {
	const createFormikProps = (name: string, changeHandler: null | ((e: React.ChangeEvent<any>) => void) = null) => {
		return {
			id: name,
			name: name,
			value: props.field.value || false,
			checked: props.field.value || false,
			onChange:
				changeHandler === null
					? props.field.onChange
					: (e: React.ChangeEvent<any>) => {
							changeHandler(e);
							props.field.onChange(e);
						},
			onBlur: props.field.onBlur,
		};
	};

	const attrs: any = {
		disabled: !!props.options.disabled,
	};

	return (
		<FormControlLabel
			style={styles.formControl}
			control={<Switch {...attrs} {...createFormikProps(props.field.name, props.options.changeHandler)} />}
			label={<span style={styles.formControlLabel}>{props.options.label}</span>}
			labelPlacement="end"
		></FormControlLabel>
	);
};

export const renderFormikSwitchInput =
	(options: InputOptions) =>
	({ field, meta }: { field: FieldInputProps<any>; meta: FieldMetaProps<any> }) => (
		<FormikSwitchInput field={field} meta={meta} options={options} />
	);

export const OptimizedFormikSwitchInputField = (options: InputOptions) => (
	<>
		{options.optimized ? (
			<FastField name={options.name}>{renderFormikSwitchInput(options)}</FastField>
		) : (
			<Field name={options.name}>{renderFormikSwitchInput(options)}</Field>
		)}
	</>
);

export const FormikSwitchInputField = React.memo(OptimizedFormikSwitchInputField);
